import apiClient from "./axios";

const BASE_PATH = "/v3/sales/iata-fuel-prices";
const CAPTURE_TASK_REQUEST_CONFIG = { timeout: 180000 };

export const salesIataFuelPriceApi = {
    getList: (params = {}) => apiClient.get(BASE_PATH, { params }),
    getById: (id) => apiClient.get(`${BASE_PATH}/${id}`),
    getOriginalPage: (id) => apiClient.get(`${BASE_PATH}/${id}/original-page`),
    getTaskRuns: (params = {}) => apiClient.get(`${BASE_PATH}/task-runs`, { params }),
    getTaskRun: (id) => apiClient.get(`${BASE_PATH}/task-runs/${id}`),
    triggerLatestCapture: () => apiClient.post(`${BASE_PATH}/task-runs/trigger-latest`, undefined, CAPTURE_TASK_REQUEST_CONFIG),
    retryTaskRun: (id) => apiClient.post(`${BASE_PATH}/task-runs/${id}/retry`, undefined, CAPTURE_TASK_REQUEST_CONFIG),
    parseTaskRunChart: (id) => apiClient.post(`${BASE_PATH}/task-runs/${id}/parse-chart`, undefined, CAPTURE_TASK_REQUEST_CONFIG),
    linkTaskRunRecord: (taskRunId, fuelPriceId) => apiClient.post(`${BASE_PATH}/task-runs/${taskRunId}/link-record`, { fuel_price_id: fuelPriceId }),
    create: (data) => apiClient.post(BASE_PATH, data),
    update: ({ id, data }) => apiClient.put(`${BASE_PATH}/${id}`, data),
    confirm: (id, data = {}) => apiClient.post(`${BASE_PATH}/${id}/confirm`, data),
    reject: (id, data) => apiClient.post(`${BASE_PATH}/${id}/reject`, data),
    batchConfirm: (recordIds, remark) => apiClient.post(`${BASE_PATH}/batch-confirm`, { record_ids: recordIds, remark }),
    batchReject: (recordIds, reason) => apiClient.post(`${BASE_PATH}/batch-reject`, { record_ids: recordIds, reason }),
    batchReopen: (recordIds, remark) => apiClient.post(`${BASE_PATH}/batch-reopen`, { record_ids: recordIds, remark }),
    getMonthSummary: (month) => apiClient.get(`${BASE_PATH}/month-summary`, { params: { month } }),
    getBillingReference: (billingMonth) => apiClient.get(`${BASE_PATH}/billing-reference`, { params: { billingMonth } }),
    getLogs: (id, params = {}) => apiClient.get(`${BASE_PATH}/${id}/logs`, { params }),
};

export default salesIataFuelPriceApi;
